import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import ContactForm from '../components/ContactForm';
import landscaping2 from '../images/landscapping 2.jpeg';
import landscaping3 from '../images/landscapping 3.jpeg';
import landscaping4 from '../images/landscapping 4.jpeg';
import landscaping11 from '../images/landscapping 11.jpeg';
import landscaping12 from '../images/landscapping 12.jpeg';
import landscaping14 from '../images/landscapping 14.jpeg';
import landscaping18 from '../images/landscapping  18.jpeg';
import landscaping19 from '../images/landscappingg 19.jpeg';
import landscaping21 from '../images/landscapping 21.jpeg';
import landscaping24 from '../images/landscapping 24.jpeg';
import landscaping26 from '../images/landscapping 26.jpeg';

// ── Landscaping Theme Tokens ───────────────────────────────
const LS = {
  bgPage:       '#f5f1eb',   // cream — 60%
  bgSection:    '#ede9e2',   // slightly darker cream
  bgCard:       '#ffffff',   // white cards
  bgDark:       '#2c2925',   // charcoal — 30%
  bgDarkCard:   '#3a3530',   // slightly lighter charcoal for cards on dark bg
  orange:       '#f97316',   // safety orange — 10%
  textDark:     '#2c2925',   // charcoal headings
  textBody:     '#4a4540',   // dark body text
  textMuted:    '#6b6560',   // muted text
  textLight:    '#f5f1eb',   // light text on dark bg
  textLightMuted: '#c4bfb8', // muted text on dark bg
  border:       '#d4cfc6',   // subtle cream border
};

const lsStyles = {
  page:         { backgroundColor: LS.bgPage, fontFamily: "'Poppins', sans-serif", color: LS.textBody },
  h1:           { fontFamily: "'Playfair Display', serif", color: LS.textLight, fontSize: '3rem', lineHeight: 1.15, margin: '0 0 1rem', fontWeight: '700' },
  h2Light:      { fontFamily: "'Playfair Display', serif", color: LS.textLight, fontSize: '2.2rem', margin: '0 0 1rem', fontWeight: '700' },
  h2Dark:       { fontFamily: "'Playfair Display', serif", color: LS.textDark, fontSize: '2.2rem', margin: '0 0 1rem', fontWeight: '700' },
  h4Dark:       { fontFamily: "'Playfair Display', serif", color: LS.textDark, fontSize: '1.05rem', margin: '0', fontWeight: '700' },
  script:       { fontFamily: "'Great Vibes', cursive", color: LS.orange, fontSize: '1.6rem', display: 'block', marginBottom: '0.25rem' },
  overlineDark: { fontSize: '0.8rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.18em', color: LS.orange, marginBottom: '0.5rem', fontFamily: "'Poppins', sans-serif" },
  overlineLight:{ fontSize: '0.8rem', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.18em', color: LS.orange, marginBottom: '0.5rem', fontFamily: "'Poppins', sans-serif" },
  accentLineDark:  { width: '40px', height: '3px', background: LS.orange, margin: '0.75rem auto 0' },
  accentLineLeft:  { width: '40px', height: '3px', background: LS.orange, margin: '0.75rem 0' },
  sectionLight: { padding: '5rem 1.5rem', backgroundColor: LS.bgPage },
  sectionAlt:   { padding: '5rem 1.5rem', backgroundColor: LS.bgSection },
  sectionDark:  { padding: '5rem 1.5rem', backgroundColor: LS.bgDark },
  cardLight:    { backgroundColor: LS.bgCard, border: `0.5px solid ${LS.border}`, borderRadius: '10px', padding: '1.25rem' },
  cardDark:     { backgroundColor: LS.bgDarkCard, border: '0.5px solid #4a4540', borderRadius: '10px', padding: '1.25rem' },
  btnPrimary:   { background: LS.orange, color: '#fff', border: 'none', borderRadius: '6px', padding: '12px 28px', fontFamily: "'Poppins', sans-serif", fontWeight: '600', fontSize: '0.95rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' },
  btnOutline:   { background: 'transparent', color: LS.orange, border: `2px solid ${LS.orange}`, borderRadius: '6px', padding: '12px 28px', fontFamily: "'Poppins', sans-serif", fontWeight: '600', fontSize: '0.95rem', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' },
};

const services = [
  'Garden Design & Installation',
  'Lawn Maintenance & Care',
  'Hardscaping (Pathways, Patios)',
  'Ready Mix Concrete',
  'Concrete Paving'
];

const galleryItems = [
  { label: 'Garden Transformation', caption: 'A stunning before-and-after showcasing our full garden overhaul — lush planting meets clean structure.', italic: 'A complete garden redesign — from bare soil to a thriving green retreat.', imgs: [{ src: landscaping18, alt: 'Landscaping 18' }, { src: landscaping19, alt: 'Landscaping 19' }], bg: '#e8f5e8' },
  { label: 'Hardscaping & Paving', caption: 'Precision paving and concrete work that adds lasting elegance and durability to any outdoor space.', italic: 'Clean lines, solid foundations — our hardscaping work speaks for itself.', imgs: [{ src: landscaping24, alt: 'Landscaping 24' }, { src: landscaping12, alt: 'Landscaping 12' }], bg: '#eae8f0' },
  { label: 'Lawn & Pathway Design', caption: 'Beautiful pathways and manicured lawns that guide the eye and invite you outdoors.', italic: 'Every path tells a story — designed to flow naturally through your landscape.', imgs: [{ src: landscaping14, alt: 'Landscaping 14' }, { src: landscaping26, alt: 'Landscaping 26' }], bg: '#eaf0e4' },
  { label: 'Residential Landscaping', caption: 'Transforming private residences with thoughtful planting schemes and outdoor living features.', italic: 'Your home deserves an exterior as beautiful as its interior.', imgs: [{ src: landscaping2, alt: 'Landscaping 2' }, { src: landscaping4, alt: 'Landscaping 4' }], bg: '#f0ece4' },
  { label: 'Feature Gardens', caption: 'Statement garden features that create a wow factor and become the heart of your outdoor space.', italic: 'Bold designs that leave a lasting impression on every visitor.', imgs: [{ src: landscaping21, alt: 'Landscaping 21' }, { src: landscaping11, alt: 'Landscaping 11' }], bg: '#e8ecf5' },
];

const testimonials = [
  { name: 'Jane Doe', company: 'Private Residence', comment: 'Transformed our backyard into our dream garden. Excellent service and attention to detail!', rating: 5 },
  { name: 'John Smith', company: 'Commercial Property', comment: 'Professional team, on-time delivery, and beautiful results. Highly recommended!', rating: 5 },
];

const Landscaping = () => {
  return (
    <div style={lsStyles.page}>

      {/* ── Hero ── */}
      <section style={{
        backgroundColor: '#2c2925',
        padding: '7rem 1.5rem',
        color: LS.textLight,
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', overflow: 'hidden' }}>
          <img
            src={landscaping14}
            alt="Landscaping"
            style={{
              float: 'right',
              width: '42%',
              maxWidth: '520px',
              marginLeft: '2rem',
              marginBottom: '1.5rem',
              borderRadius: '16px',
              boxShadow: '0 24px 48px rgba(0,0,0,0.35)',
              display: 'block',
            }}
          />

          <div style={{ overflow: 'hidden' }}>
            <span style={lsStyles.script}>Outdoor Elegance</span>
            <p style={lsStyles.overlineLight}>Professional Landscaping</p>
            <h1 style={lsStyles.h1}>
              Beautiful Gardens<br />Designed for Your Life
            </h1>
            <p style={{ color: LS.textLightMuted, maxWidth: '560px', margin: '0 0 2rem', fontFamily: "'Poppins', sans-serif", lineHeight: 1.7 }}>
              Create inviting outdoor living spaces with our expert landscaping design, installation, and maintenance.
            </p>
            <button style={lsStyles.btnPrimary}>Book a Design Consult <ArrowRight size={18} /></button>
          </div>
        </div>
      </section>

      {/* ── Services ── */}
      <section style={lsStyles.sectionLight}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <span style={lsStyles.script}>What We Offer</span>
            <p style={lsStyles.overlineDark}>Our Services</p>
            <h2 style={lsStyles.h2Dark}>Landscaping Solutions</h2>
            <div style={lsStyles.accentLineDark}></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1rem' }}>
            {services.map((service, i) => (
              <div key={i} style={lsStyles.cardLight}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
                  <span style={{ color: LS.orange, fontSize: '1.2rem' }}>✓</span>
                  <h4 style={lsStyles.h4Dark}>{service}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Gallery ── */}
      <section style={lsStyles.sectionAlt}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <span style={lsStyles.script}>Our Work</span>
            <p style={lsStyles.overlineDark}>Portfolio</p>
            <h2 style={lsStyles.h2Dark}>Our Previous Projects</h2>
            <div style={lsStyles.accentLineDark}></div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '3rem' }}>
            {galleryItems.map((item, i) => (
              <div key={i}>
                <p style={{ ...lsStyles.overlineDark, textAlign: 'center' }}>{item.label}</p>
                <p style={{ textAlign: 'center', color: LS.textBody, fontSize: '0.95rem', marginBottom: '1.25rem', fontFamily: "'Poppins', sans-serif" }}>{item.caption}</p>
                <div style={{ backgroundColor: item.bg, borderRadius: '12px', padding: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap', border: `0.5px solid ${LS.border}` }}>
                  {item.imgs.map((img, j) => (
                    <div key={j} style={{ flex: '1 1 calc(50% - 0.5rem)', minWidth: '200px', borderRadius: '8px', overflow: 'hidden' }}>
                      <img src={img.src} alt={img.alt} style={{ width: '100%', height: '100%', objectFit: 'cover', display: 'block' }} />
                    </div>
                  ))}
                </div>
                <p style={{ textAlign: 'center', color: LS.textMuted, fontSize: '0.85rem', fontStyle: 'italic', marginTop: '0.75rem', fontFamily: "'Poppins', sans-serif" }}>{item.italic}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Testimonials ── */}
      <section style={lsStyles.sectionDark}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '3rem' }}>
            <span style={lsStyles.script}>Happy Clients</span>
            <p style={lsStyles.overlineLight}>What Clients Say</p>
            <h2 style={lsStyles.h2Light}>Testimonials</h2>
            <div style={lsStyles.accentLineDark}></div>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))', gap: '1.5rem' }}>
            {testimonials.map((t, i) => (
              <div key={i} style={lsStyles.cardDark}>
                <div style={{ marginBottom: '0.75rem', fontSize: '1.1rem' }}>{'⭐'.repeat(t.rating)}</div>
                <p style={{ fontStyle: 'italic', color: LS.textLightMuted, marginBottom: '1rem', fontFamily: "'Poppins', sans-serif", lineHeight: 1.6 }}>"{t.comment}"</p>
                <h4 style={{ fontFamily: "'Playfair Display', serif", color: LS.textLight, margin: '0 0 0.2rem', fontSize: '1rem' }}>{t.name}</h4>
                <p style={{ margin: 0, color: LS.orange, fontSize: '0.85rem' }}>{t.company}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CTA ── */}
      <section style={{
        backgroundImage: `linear-gradient(rgba(44,41,37,0.80), rgba(44,41,37,0.80)), url('https://images.unsplash.com/photo-1552664730-d307ca884978?w=1200&h=600&fit=crop')`,
        backgroundSize: 'cover', backgroundPosition: 'center',
        padding: '5rem 1.5rem', textAlign: 'center'
      }}>
        <span style={lsStyles.script}>Let's Get Started</span>
        <h2 style={lsStyles.h2Light}>Ready to Transform Your Outdoor Space?</h2>
        <p style={{ color: LS.textLightMuted, marginBottom: '2rem', fontSize: '1.05rem', fontFamily: "'Poppins', sans-serif" }}>Get a free landscaping consultation today</p>
        <button style={lsStyles.btnPrimary}>Request Free Consultation <ArrowRight size={18} /></button>
      </section>

      <ContactForm />
    </div>
  );
};

export default Landscaping;